// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

// Kullanicinin ekranda gordugu SON hata mesaji. "ELPO'ya bildir" formu bunu talebe kendiliginden
// ekler; kullanici hatayi elle kopyalamak ya da anlatmak zorunda kalmaz.
// Kaynaklar: hata bildirimleri (elpo:toast olayi, type=error) ve hata ekrani (ErrorBoundary).
// sessionStorage'da durur: hata ekranindan bildir sayfasina gecerken sayfa yenilense de kaybolmaz.

const ANAHTAR = 'elpo.sonHata';

export interface SonHata {
  readonly mesaj: string;
  readonly sayfa: string;
  readonly zaman: number;
}

export function sonHatayiKaydet(mesaj: string, sayfa = window.location.pathname): void {
  const temiz = mesaj.trim();
  if (!temiz) return;
  try {
    sessionStorage.setItem(ANAHTAR, JSON.stringify({ mesaj: temiz.slice(0, 500), sayfa, zaman: Date.now() }));
  } catch { /* gizli pencerede depolama kapali olabilir; bildirim yine gider, yalniz hata eklenmez */ }
}

/** Son 30 dakikadaki hata; daha eskisi bugunku sorunla ilgisiz olabilecegi icin eklenmez. */
export function sonHatayiOku(): SonHata | null {
  try {
    const ham = sessionStorage.getItem(ANAHTAR);
    if (!ham) return null;
    const h = JSON.parse(ham) as SonHata;
    return Date.now() - h.zaman < 30 * 60_000 ? h : null;
  } catch {
    return null;
  }
}

export function sonHatayiSil(): void {
  try { sessionStorage.removeItem(ANAHTAR); } catch { /* bkz. sonHatayiKaydet */ }
}

window.addEventListener('elpo:toast', (e) => {
  const d = (e as CustomEvent<{ type?: string; message?: string }>).detail;
  if (d?.type === 'error' && d.message) sonHatayiKaydet(d.message);
});
